var pug = require("!../../node_modules/pug-runtime/index.js");

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;pug_html = pug_html + "\u003Cdiv class=\"md_is_artlist_container\"\u003E\u003Cdiv class=\"md_is_artlist\"\u003E\u003Cdiv class=\"md_is_artlist_loader\"\u003E\u003Ci class=\"icon-aggiorna\"\u003E\u003C\u002Fi\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";;return pug_html;};
module.exports = template;


//////////////////
// WEBPACK FOOTER
// ./src/templates/container.pug
// module id = 12
// module chunks = 0